import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './controller/reducers';
import { save, load } from 'redux-localstorage-simple';

const createStoreWithMiddleware = compose(applyMiddleware(thunk, save()))(createStore);
const store = createStoreWithMiddleware(reducers, load());
export { store };
